import React from 'react';
import { MutualActionPlan, MutualActionPlanItem } from 'src/common/interfaces/mutual_action_plan.interface';
import { DeleteRegularIcon } from 'src/monet/icons';
import { ContextMenuButton } from './components/context-menu-button';
import { useEditorStore } from './editor-store';

type Props = {
  item: MutualActionPlanItem;
  mutualActionPlan: {
    uuid: MutualActionPlan['uuid'];
  };
};

export const MutualActionPlanItemContextMenuContent = ({ item, mutualActionPlan }: Props) => {
  const dispatchUserEditorAction = useEditorStore((state) => state.dispatchUserEditorAction);
  const clearContextMenuState = useEditorStore((state) => state.clearContextMenuState);

  const onDeleteTask = () => {
    dispatchUserEditorAction({
      type: 'delete-mutual-action-plan-item',
      itemUuid: item.uuid,
      mutualActionPlan: mutualActionPlan,
    });
    clearContextMenuState();
  };

  return (
    <>
      <ContextMenuButton onClick={onDeleteTask} label='Delete task'>
        <DeleteRegularIcon className='text-inherit w-4 h-4' />
      </ContextMenuButton>
    </>
  );
};
